import { render, staticRenderFns } from "./SolicitudesCambio.vue?vue&type=template&id=6e2a6f98&"
import script from "./SolicitudesCambio.vue?vue&type=script&lang=js&"
export * from "./SolicitudesCambio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports